<form
  [dir]="rtlEnabled ? 'rtl' : 'auto'"
  id="MFAform"
  method="POST"
  (ngSubmit)="confirmSecondFactor()"
  [formGroup]="Form"
  *ngIf="viewState.showSecondFactor && (resAsync | async)"
>
  <div
    class="MFA-form"
    *ngIf="viewState.showSecondFactor && (resAsync | async)"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="30px"
  >
    <div class="information-msg" *ngIf="secondFactor.setup">
      {{ res.get('SecondFactor-SetupTitle') }}
    </div>
    <div class="information-msg" *ngIf="secondFactor.setupDeprecated">
      {{ res.get('SecondFactor-SetupDeprecatedTitle') }}
    </div>
    <div class="information-msg" *ngIf="secondFactor.input">
      {{ res.get('SecondFactor-InputTitle') }}
    </div>
    <div class="information-msg" *ngIf="secondFactor.invalidConfig">{{ res.get('SecondFactor-InvalidConfig') }}</div>

    <button
      class="button button-invalid"
      *ngIf="secondFactor.invalidConfig"
      style="width: 65%"
      (click)="cancelSecondFactor()"
    >
      {{ res.get('Cancel') }}
    </button>
    <div class="msgError" *ngIf="secondFactor.showInvalidCodeMessage">
      {{ res.get('SecondFactor-InvalidCode') }}
    </div>
    <div
      class="setupTwoFactor"
      [ngClass]="{ qrCodePosition: secondFactor.showInput }"
      fxLayoutAlign="space-around center"
      fxLayoutGap="20px"
      fxLayout="column"
    >
      <div
        class="optinalTwoFactorButtons"
        *ngIf="secondFactor.shouldSetup"
        fxLayout="column"
        fxLayoutAlign="space-around center"
        fxLayoutGap="30px"
      >
        <span class="msg-notification"> {{ this.res.get('SecondFactor-ShouldSetup') }}</span>
        <div fxLayout="column" fxLayoutGap="20px" style="width: 100%">
          <button class="button button-first" (click)="setOptionalSecondFactor()">
            {{ this.res.get('Login-Setup-MFA') }}
          </button>
          <button class="button button-second" (click)="confirmSecondFactor()">
            {{ this.res.get('Login-Skip-MFA') }}
          </button>
        </div>
      </div>

      <div fxLayoutGap="15px" fxLayout="column" *ngIf="secondFactor.showQRCode">
        <img
          fxFlexAlign="center"
          class="qrCode"
          src="{{ baseUrl }}/QR/{{ secret }}?otpauth=totp&user={{ username.value }}&issuer={{ issuer }}"
          alt=""
        />
        <span class="secretInfoSpan">{{ this.res.get('SecondFactor-SecretInfo') }}</span>
        <span>{{ this.secret }}</span>
      </div>
      <div class="twoFactorCode" *ngIf="secondFactor.showInput" fxLayout="column" fxLayoutGap="20px">
        <div
          class="input-qrCode"
          [ngStyle]="secondFactor.showQRCode ? { color: 'black' } : { color: 'white' }"
          fxLayout="row"
          fxLayoutAlign="space-around center"
          fxLayoutGap="20px"
        >
          <div *ngFor="let holder of placeholders; index as i">
            <input
              #input
              id="input"
              (click)="onClick($event)"
              (paste)="onPaste($event, i)"
              (input)="onInput($event, i)"
              (keydown)="onKeydown($event, i)"
              [type]="inputType"
              [disabled]="false"
              [attr.inputmode]="inputMode"
              [attr.autocapitalize]="true"
              autocomplete="one-time-code"
            />
          </div>
        </div>
        <button
          [type]="'submit'"
          #submitButton
          id="confirmMFACode"
          class="button confirmButton"
          (click)="confirmSecondFactor()"
          [ngStyle]="{ opacity: !confirmationcodeFilled ? '0.5' : '1' }"
          [disabled]="!confirmationcodeFilled"
        >
          {{ res.get('Login-Login') }}
        </button>
        <button class="button cancelButton" (click)="cancelSecondFactor()" [disabled]="secondFactor.setupDeprecated">
          {{ res.get('Cancel') }}
        </button>
      </div>
    </div>
  </div>

  <div class="information-msg" *ngIf="viewState.showChangePassword">
    {{ res.get('Login-NeedsPasswordChangeTitle') }}
  </div>
</form>
<form
  [dir]="rtlEnabled ? 'rtl' : 'auto'"
  id="form"
  class="login-form {{ errorClass ? ' ' + errorClass : '' }}"
  [formGroup]="Form"
  method="POST"
  (ngSubmit)="onSubmit()"
  *ngIf="!showLoader && (resAsync | async)"
>
  <!-- <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex="flex" class="webapi-info">
      <ng-container *ngIf="(currentWebApiInfo$ | async) as currentWebApiInfo">
        <span>WebAPI-Dienst:&nbsp;</span>
        <span *ngIf="currentWebApiInfo.isBaseURLInvalid" class="error">Nicht erreichbar! Bitte konfigurieren!</span>
        <span *ngIf="!currentWebApiInfo.isBaseURLInvalid">{{currentWebApiInfo.displayText}} (Version:
          {{currentWebApiInfo.version}})</span>
      </ng-container>
    </div>
    <div fxFlex="nogrow">
      <button *ngIf="isChangingWebApiSupported" mat-icon-button type="button" tabindex="-1"
        class="InputButton WebApiEditorButton" (click)="editWebAPI()" matTooltip="Datendienst wechseln"
        aria-label="Datendienst wechseln">
        <mat-icon class="WebApiEditorIcon" svgIcon="login_webapi-editor"></mat-icon>
      </button>
    </div>
  </div> -->

  <!-- Username Field -->

  <mat-form-field *ngIf="viewState.showLogin" class="full-width formInput" floatLabel="never">
    <mat-label class="Label">{{ this.res.get('Login-Username') }} </mat-label>
    <!-- <mat-icon matPrefix class="PrefixIcon">person</mat-icon> -->
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <input
        matInput
        id="username"
        name="username"
        [type]="'text'"
        [formControl]="username"
        [(ngModel)]="value"
        (keyup)="clearLastValidation()"
        (focus)="$event.target.select()"
        (click)="onInputClick()"
        (blur)="onInputLeave($event)"
        required
      />
      <button matSuffix class="InputButton" type="button" tabindex="-1" (click)="value = ''; password.setValue('')">
        <div class="clearBlack">
          <mat-icon [svgIcon]="res.svgName('PasswordRemove-Image')" *ngIf="value" (click)="onClearClick()"></mat-icon>
        </div>
      </button>
    </div>
    <mat-error *ngIf="username.hasError('required') || errorExist" id="Error">
      <!-- Username is <strong>required</strong> -->
      <div [innerHTML]="this.res.get('Login-ErrorUserName')"></div>
      <div class="waring">
        <mat-icon [svgIcon]="res.svgName('Warning-Image')" *ngIf="hasUserName"> </mat-icon>
      </div>
    </mat-error>
  </mat-form-field>
  <!-- Password Field -->
  <mat-form-field *ngIf="viewState.showLogin" class="full-width" floatLabel="never">
    <mat-label class="Label">{{ this.res.get('Login-Password') }}</mat-label>
    <!-- <mat-icon matPrefix class="PrefixIcon">lock</mat-icon> -->
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <input
        matInput
        id="password"
        name="password"
        [ngClass]="pw_vis ? 'password_visible' : 'password_hidden'"
        [type]="pw_vis ? 'text' : 'password'"
        [formControl]="password"
        autocomplete="off"
        (keyup)="clearLastValidation()"
        (focus)="onPasswordFocus($event)"
        (beforeinput)="onPasswordBeforeInput()"
        (change)="onPasswordFocus($event)"
        (click)="onInputClick(); onPasswordFocus($event)"
        (blur)="onInputLeave($event)"
        required
      />
      <button
        *ngIf="isPasswordChanged && hasPassword"
        matSuffix
        class="InputButton"
        type="button"
        tabindex="-1"
        (click)="pw_vis = !pw_vis"
      >
        <div [ngClass]="hasPassword ? (pw_vis ? 'hidePass' : 'showPass') : 'noPass'">
          <mat-icon [svgIcon]="res.svgName('PasswordShow-Image')"></mat-icon>
        </div>
      </button>
      <button
        *ngIf="!isPasswordChanged && hasPassword"
        matSuffix
        class="InputButton"
        type="button"
        tabindex="-1"
        (click)="password.setValue('')"
      >
        <div class="clearBlack">
          <mat-icon [svgIcon]="res.svgName('PasswordRemove-Image')" (click)="onClearClick()"></mat-icon>
        </div>
      </button>
    </div>
    <mat-error *ngIf="password.hasError('required') || errorExist" id="Error">
      <!-- Password is <strong>required</strong> -->
      <div [innerHTML]="this.res.get('Login-ErrorPassword')"></div>
      <div class="waring">
        <mat-icon [svgIcon]="res.svgName('Warning-Image')" *ngIf="hasPassword"> </mat-icon>
      </div>
    </mat-error>
    <!-- <mat-hint *ngIf="Errors && Form.valid" class="ErrorServer" (click)="showBtn()">
      <mat-error>
        {{ ErrorMessage }}
        <mat-icon matSuffix class="WarningIcon">
          auth_error
        </mat-icon>
      </mat-error>
    </mat-hint> -->
  </mat-form-field>
  <div *ngIf="isPasswordForgotten" class="Password-forgotten-bloc" fxLayout="row">
    <div class="Password-forgotten-title">{{ this.res.get('Login-Password-Forgotten') }}</div>
    <span id="PasswordForgotten" class="forgot-password-btn"></span>
  </div>
  <div *ngIf="!ErrorMessage">
    <div *ngIf="autoDisplayButtons || (hasUserName && hasPassword)" class="buttons">
      <button mat-raised-button id="LoginButton" class="loginBtn" name="submit">
        {{ this.res.get('Login-Login') }}
      </button>

      <button type="button" mat-button class="cancelBtn" mat-stroked-button (click)="back()">
        {{ this.res.get('Login-Cancel') }}
      </button>
    </div>
  </div>
  <div class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}" *ngIf="ErrorMessage">
    <div class="waring">
      <mat-icon class="iconError" [svgIcon]="res.svgName('Warning-Image')"></mat-icon>
    </div>
    <div class="msgError">{{ this.res.get('Login-Error') }}</div>
    <div class="descriptionError" [title]="ErrorMessage">
      <span>{{ this.res.get('Login-ErrorDescriptionMessage-1') }}</span>
      <span>{{ this.res.get('Login-ErrorDescriptionMessage-2') }}</span>
    </div>

    <div class="descriptionError" *ngIf="loginLockoutWarning">
      {{ res.get('Login-Lockout-Warning') }}
      {{ this.lockoutRetries }}
    </div>
    <div class="descriptionError" *ngIf="loginLockout">
      {{ res.get('Login-Lockout-Time', this.lockoutSeconds) }}
    </div>
    <div class="descriptionError" *ngIf="loginLockout">
      {{ res.get('Login-Lockout-Time-2', this.lockoutEndString) }}
    </div>
  </div>
  <div *ngIf="hasUserName && false" style="text-align: center">
    <a class="bottom-link" (click)="restorePassword()">{{ this.res.get('Login-RestorePassword') }}</a>
  </div>
  <div *ngIf="isChangingWebApiSupported && isAllowBaseURLChange && !specialLogin" style="text-align: center">
    <a class="bottom-link" (click)="editWebAPI()">{{ this.res.get('Login-EditWebApi') }}</a>
  </div>

  <!-- <button mat-raised-button id="LoginButton" matTooltip="Anmelden" name="submit">
    Anmelden
  </button> -->
</form>
<div
  class="loaderClass {{ errorClass ? ' ' + errorClass : '' }}"
  *ngIf="showLoader && viewState.showLogin && (resAsync | async)"
>
  <div class="titleStyle">{{ this.res.get('Login-WelcomeMessage-1') }}</div>
  <div class="msgStyle">{{ this.res.get('Login-WelcomeMessage-2') }}</div>
  <abcLoader
    [id]="'loaderLogin'"
    [class]="'loader'"
    [show]="true"
    [percentageValue]="false"
    [mode]="'indeterminate'"
    [value]="loaderValue"
  >
  </abcLoader>
</div>
